import { render, staticRenderFns } from "./chipinplus-indexed.vue?vue&type=template&id=36d6591c&scoped=true&"
import script from "./chipinplus-indexed.vue?vue&type=script&lang=js&"
export * from "./chipinplus-indexed.vue?vue&type=script&lang=js&"
import style0 from "./chipinplus-indexed.vue?vue&type=style&index=0&id=36d6591c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d6591c",
  null
  
)

export default component.exports